import clientAdmin from 'services/api/v1/admin/client'

export async function getUserHttp(userId: string) {
  return await clientAdmin.get(`/users/${userId}`)
}
